"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTooltipStylesByVariant = function getTooltipStylesByVariant(theme) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return {
    "default": {
      color: theme.palette.text.primary
    },
    error: {
      color: theme.palette.error.main
    }
  }[variant];
};

var Tooltip = (0, _material.styled)(function (_ref) {
  var className = _ref.className,
      title = _ref.title,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'div' : _ref$component,
      startIcon = _ref.startIcon,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "title", "component", "startIcon", "children", "classes"]);
  return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, (0, _extends2["default"])({}, props, {
    classes: _objectSpread(_objectSpread({}, classes), {}, {
      popper: (0, _classnames["default"])(className, classes === null || classes === void 0 ? void 0 : classes.popper)
    }),
    title: startIcon ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
      mr: 1
    }, startIcon), title) : title
  }), /*#__PURE__*/_react["default"].createElement(Component, null, children));
})(function (_ref2) {
  var _ref3;

  var theme = _ref2.theme,
      variant = _ref2.variant;
  return _ref3 = {
    zIndex: theme.zIndex.modal - 1
  }, (0, _defineProperty2["default"])(_ref3, "& .".concat(_material.tooltipClasses.tooltip), _objectSpread({
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, 0.2)",
    fontSize: '0.75rem',
    padding: theme.spacing(1, 2)
  }, getTooltipStylesByVariant(theme, variant))), (0, _defineProperty2["default"])(_ref3, "& .".concat(_material.tooltipClasses.arrow), {
    color: theme.palette.common.white
  }), (0, _defineProperty2["default"])(_ref3, "& .".concat(_material.tooltipClasses.arrow, ":before"), {
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, 0.2)"
  }), _ref3;
});
var _default = Tooltip;
exports["default"] = _default;